import HeroBanner from "./components/HeroBanner";
import HotComics from "./components/HotComics";
import CategorySection from "./components/CategorySection";
import LatestUpdates from "./components/LatestUpdates";
import FeaturesStrip from "./components/FeaturesStrip";
import NewsletterSection from "./components/NewsletterSection";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroBanner />
        <HotComics />
        <CategorySection />
        <LatestUpdates />
        <FeaturesStrip />
        <NewsletterSection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "羞羞色漫",
            url: "https://xiuxiuse.com",
            description:
              "羞羞色漫是深受读者喜爱的成人漫画平台，汇聚海量精选漫画资源，涵盖多种风格与题材，画质清晰、更新及时，为18岁以上成年用户提供流畅阅读体验。",
            potentialAction: {
              "@type": "SearchAction",
              target: "https://xiuxiuse.com/search?q={search_term_string}",
              "query-input": "required name=search_term_string",
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "羞羞色漫",
            url: "https://xiuxiuse.com",
            description:
              "羞羞色漫是深受读者喜爱的成人漫画平台，精选漫画资源汇聚，为18岁以上成年用户提供高清流畅的漫画阅读体验。",
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "羞羞色漫 - 精选漫画资源汇聚平台",
            description:
              "羞羞色漫是深受读者喜爱的成人漫画平台，汇聚海量精选漫画资源，涵盖多种风格与题材，画质清晰、更新及时，为18岁以上成年用户提供流畅阅读体验，立即进入羞羞色漫探索精彩内容。",
          }),
        }}
      />
    </>
  );
}